import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import routes from "./routes";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          {routes.map((prop, key) => {
            const Element = prop.component;
            const RouteType = prop.type || Route;

            // Handle both array and string paths
            const paths = Array.isArray(prop.path) ? prop.path : [prop.path];

            return paths.map((path) => {
              // Handle PrivateRoute differently (must wrap element)
              if (RouteType !== Route) {
                return (
                  <Route
                    key={`${key}-${path}`}
                    path={path}
                    element={
                      <RouteType>
                        <Element />
                      </RouteType>
                    }
                  />
                );
              }

              // Normal public route
              return (
                <Route
                  key={`${key}-${path}`}
                  path={path}
                  element={<Element />}
                />
              );
            });
          })}
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </div>
  );
}

export default App;
